import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-574339c6")

_pushScopeId("data-v-574339c6")
const _hoisted_1 = { class: "admin-contract-user-edit" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "title" }, "現ユーザーID（メールアドレス）：", -1)
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "title" }, "氏名（任意）：", -1)
const _hoisted_6 = {
  key: 3,
  class: "value"
}
const _hoisted_7 = { class: "admin-commands" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "適用", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock(_component_modal, {
    isShow: _ctx.isShowModalInner,
    "onUpdate:isShow": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowModalInner = $event)),
    title: _ctx.isDeleteMode ? 'ユーザー削除' : 'ユーザー編集',
    isLeftTitle: true,
    isFitSize: true,
    onKeydown: _withKeys(_withModifiers(_ctx.applyInner, ["prevent"]), ["enter"])
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("label", {
            class: "value",
            disabled: _ctx.isDeleteMode
          }, _toDisplayString(_ctx.editModel.email), 9, ["disabled"]),
          (!_ctx.isDeleteMode)
            ? (_openBlock(), _createBlock("label", _hoisted_4, "新ユーザーID（メールアドレス）："))
            : _createCommentVNode("", true),
          (!_ctx.isDeleteMode)
            ? _withDirectives((_openBlock(), _createBlock("input", {
                key: 1,
                class: "value",
                type: "text",
                maxlength: _ctx.consts.maxEMailLength,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.email = $event))
              }, null, 8, ["maxlength"])), [
                [_vModelText, _ctx.user.email]
              ])
            : _createCommentVNode("", true),
          _createVNode(_component_ErrorMessage, {
            class: "value",
            messages: _ctx.errorMessages.email
          }, null, 8, ["messages"]),
          _hoisted_5,
          (!_ctx.isDeleteMode)
            ? _withDirectives((_openBlock(), _createBlock("input", {
                key: 2,
                class: "value",
                type: "text",
                maxlength: _ctx.consts.maxUserNameLength,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.name = $event))
              }, null, 8, ["maxlength"])), [
                [_vModelText, _ctx.user.name]
              ])
            : _createCommentVNode("", true),
          (_ctx.isDeleteMode)
            ? (_openBlock(), _createBlock("label", _hoisted_6, _toDisplayString(_ctx.user.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          (!_ctx.isDeleteMode)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "app-button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyInner && _ctx.applyInner(...args)))
              }, [
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          (_ctx.isDeleteMode)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                class: "danger-button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
              }, [
                _hoisted_9
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isShow", "title", "onKeydown"]))
})